export enum OnboardingRequestType {
  'ExtendedOnboarding' = 'Initial',
  'InitialOnboarding' = 'Initial',
  'Reactivation' = 'Reactivation',
  'EntityExtension' = 'EntityExtension',
  'SubTierOnboarding' = 'Initial'
}

